<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title class="d-flex justify-content-between align-items-center">
            <span>Purchase Order Details for PO: {{poNumber}}</span>
              <!-- Go back Button -->
            <button mat-mini-fab (click)="goBackToPoList()" color="accent"   class="close-btn" aria-label="Close">
                <mat-icon>close</mat-icon>
            </button>
            <!-- Download Button -->
            <button mat-mini-fab  matTooltip="Download Records"  color="accent"  class="download-btn"
               *ngIf="dataSource.data.length > 0" (click)="exportDataToExcel()">
                <mat-icon>download</mat-icon>
            </button>
        </mat-card-title>
        <mat-card-content>
            <div class="row" style="padding: 5px">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                        <app-column-selector [allColumns]="allColumns" [defaultColumns]="defaultColumns"
                            storageKey="findiPoDetailDisplayedColumns" [(value)]="displayedColumns">
                        </app-column-selector>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                        <app-filter-input *ngIf="dataSource.data.length  > 0"
                            (filterChanged)="applyFilter($event)"></app-filter-input>
                    </div>
                </div>
                <div class="row" style="margin: auto">
                    <div class="wrapper">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
                            aria-label="Purchase order table" (matSortChange)="announceSortChange($event)"
                            *ngIf="dataSource.data.length > 0">
                            <ng-container matColumnDef="findiPurchaseOrderDetailId">
                                <td mat-cell *matCellDef="let element">
                                    {{ element.findiPurchaseOrderDetailId }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ProductName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Product">
                                    Product
                                </th>
                                <td mat-cell *matCellDef="let element;">
                                    {{ element.productName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="CategoryName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Category Name">
                                    Category
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.categoryName}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="SubCategoryName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by SubCategory">
                                    SubCategory
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.subCategoryName }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="BrandName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Brand">
                                    Brand
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.brandName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="OrderQuantity">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by OrderQuantity">
                                    Order Qty
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.orderQuantity }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="ReceivedQuantity">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by ReceivedQuantity">
                                    Rx Qty
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.receivedQuantity }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="WarrantyInMonths">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Vendor Code">
                                    Warranty
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.warrantyInMonths }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="UnitName">
                                <th mat-header-cell *matHeaderCellDef>Unit</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.unitName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="UnitPrice">
                                <th mat-header-cell *matHeaderCellDef>Unit Price</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.unitPrice }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="CreatedBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Created By">
                                    Created By
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdBy }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="CreatedOn">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by createdOn">
                                    Created On
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdOn | date : "dd-MMM-yyyy" }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="UpdatedBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Updated By">
                                    Updated By
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.updatedBy }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="UpdatedOn">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by updatedOn">
                                    Updated On
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.updatedOn | date : "dd-MMM-yyyy" }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updateRemarks">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by updateRemarks">
                                    Update Remarks
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.updateRemarks }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="editDetail">
                                <th mat-header-cell *matHeaderCellDef> Edit </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-mini-fab aria-label="Edit"
                                        [matTooltip]="element.isAssetCreated ? 'Asset created for this order.' : 'Edit Purchase order detail'"
                                        [disabled]="element.isAssetCreated"
                                        (click)="updateOrderDetails($event, element)">
                                        <mat-icon>create</mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="deletePoDetail">
                                <th mat-header-cell *matHeaderCellDef> Delete </th>
                                <td mat-cell *matCellDef="let element">
                                    <!-- Wrap in span to enable tooltip even when disabled -->
                                    <span
                                        matTooltipPosition="above"
                                        [matTooltip]="element.isAssetCreated ? 'Asset created for this order.' : 'Delete Purchase order detail'">
                                        <button mat-mini-fab  [disabled]="element.isAssetCreated" 
                                            [ngClass]="{
                                                        'mat-mini-fab': true,
                                                        'mat-accent': !element.isAssetCreated,
                                                        'disabled-edit-button': element.isAssetCreated
                                                        }" (click)="softDeletePoDetail($event, element)"
                                                        
                                            aria-label="Delete">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </span>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                        <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
                        </mat-paginator>
                        <div *ngIf="isLoaderResult" class="custSpinner"></div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>